import Cookies from 'js-cookie'
import router from '@/router';


//属性
const state = { 
  keepAliveComponent:null,//keepAlive组件对象
  TypeID:0,
  factoryList:null,//工厂
  supplierList:null,//供应商
  customerList:null,//客户
  customerPurchCode:null,//客户采购订单编号
  unitList:localStorage.getItem('unitList') ? JSON.parse( localStorage.getItem('unitList')) : null,//计量单位
  matterTypeList:localStorage.getItem('matterTypeList') ? JSON.parse(localStorage.getItem('matterTypeList')) : null,//物料类型
  matteGroup:localStorage.getItem('matteGroup') ? JSON.parse(localStorage.getItem('matteGroup')) : null,//物料组
  companyList:localStorage.getItem('companyList') ? JSON.parse(localStorage.getItem('companyList')) : null,//公司列表
  customerPurchList:localStorage.getItem('customerPurchList') ? JSON.parse(localStorage.getItem('customerPurchList')) : null,//销售订单列表

  materialList:localStorage.getItem('materialList') ? JSON.parse(localStorage.getItem('materialList')) : null,//物料编码
  distriChannelList:localStorage.getItem('distriChannelList') ? JSON.parse(localStorage.getItem('distriChannelList')) : null,//分销渠道
  salesPriceList:localStorage.getItem('salesPriceList') ? JSON.parse(localStorage.getItem('salesPriceList')) : null,//销售价格
  priceUnitList:localStorage.getItem('priceUnitList') ? JSON.parse(localStorage.getItem('priceUnitList')) : null,//价格单位
  basicUnitList:localStorage.getItem('basicUnitList') ? JSON.parse(localStorage.getItem('basicUnitList')) : null,//基本单位
  selectedMatterStockList:localStorage.getItem('selectedMatterStockList') ? JSON.parse(localStorage.getItem('selectedMatterStockList')) : [],//已选的物料数组，从物料库存里拿的,(采购退库-添加，销售出库-添加 ，维护芳疗批次-添加 )
  
  selectedMatterList:[],//已选的物料数组,从物料数据里拿的,（采购入库-添加，销售退货-添加）
  selectedMatterSale:[],//已选的物料数组，从物料库存里拿的,(创建销售订单)
  selectedMatterBom:[],//已选的物料数组，从物料库存里拿的,(创建销售订单)

  selectedMatterSaleSend:[],//已选的物料数组，根据销售订单号带出来,(销售订单发货)
  selectedMatterSaleCancel:[],//已选的物料数组，根据销售订单号带出来,(销售订单退货)
  selectedMatterSaleHelp:[],//已选的物料数组，根据销售订单号带出来,(销售订单退货)
  detailData:{},//已选的物料，根据销售订单号带出来,(销售订单转生产订单)
  batchCharact:{},//已选的物料数组，发送给维护芳疗批次特性
  selectedMatterProductOrder:[],//已选的物料数组，(创建生产订单)
  selectedMatterProductOrders:[],//已选的bom列表，(创建生产订单)
  productOrderNos:'',//生产订单列表被选中时的生产订单号
  productOrderId:'',//生产订单列表被选中时的生产订单ID
  CheckBomList:[],//物料核对信息弹窗信息
  ProdOrderInputList:{},//储存生产订单入库信息
  ProdOrderOutList:{},//储存生产订单出库信息
  backflush:{},//储存生产成品入库反冲信息
  backflushList:[],//储存生产成品入库反冲-查询生产订单入库反冲列表
  issueBackflush:{},//储存生产成品出库反冲信息
  PurcOrEditComId:''//储存采购订单编辑时的公司Id
}

//同步更改的 - 更改vuex中state的唯一方法就是提交mutation，mutation的代码都是同步的
const mutations = {

}

//异步修改
const actions = {
  //设置公司列表
  setCompanyList({state,commit},list){
    state.companyList = list;
    //commit('setCompanyList',list);
  },
  setFactoryList({state,commit},list){
    state.factoryList = list;
   // console.log(list,'=== 列表 ==');
    //commit('setFactoryList',list);
  },
  setSupplierList({state,commit},list){
    state.supplierList = list;
    //commit('setSupplierList',list);
  },
  setMatterTypeList({state,commit},list){
    state.matterTypeList = list;
    //commit('setMatterTypeList',list);
  },
  setMatteGroup({state,commit},list){
    state.matteGroup = list;
    //commit('setMatteGroup',list);
  },
  setUnitList({state,commit},list){
    state.unitList = list;
  },
  setMaterialList({state,commit},list){
    state.materialList = list;
  },
  setDistriChannelList({state,commit},list){
    state.distriChannelList = list;
  },
  setSalesPriceList({state,commit},list){
    state.salesPriceList = list;
  },
  setPriceUnitList({state,commit},list){
    state.priceUnitList = list;
  },
  setBasicUnitList({state,commit},list){
    state.basicUnitList = list;
  },


  //设置已选物料 - 物料列表里
  setSelectedMatterList({state,dispatch,commit},{arr,other}){
    console.log(arr);
    if(!arr) return;
    let selectedList = state.selectedMatterList;//已选数组
    arr.forEach((item,index)=>{
      let obj = selectedList.find(v=>v.selectId===item.selectId);
      if(!obj){
        let obj = item;
        obj.selectId = item.materialCode;
        obj.factoryCode = other.factoryCode;//工厂
        obj.factoryDesc = other.factoryDesc;//工厂
        obj.factoryId = other.factoryId;//工厂

        obj.inventoryCode = other.inventoryCode;//库存地
        obj.inventoryDesc =other.inventoryDesc;
        obj.inventoryId = other.inventoryId;

        obj.supplierCode = other.supplierCode;//供应商
        obj.supplierDesc = other.supplierDesc;
        obj.supplierId = other.supplierId;

        obj.customerCode = other.customerCode;//客户
        obj.customerDesc = other.customerDesc;
        obj.customerId = other.customerId;

        state.selectedMatterList.push(obj);
      }
    });
  },
  
  //设置已选物料- 库存列表      
  setSelectedMatterStockList({state,dispatch,commit},{arr,other}){
    if(!arr) return;
    let selectedList = state.selectedMatterStockList;//已选数组
    arr.forEach((item,index)=>{
      let obj = selectedList.find(v=>v.selectId===item.selectId);
      if(!obj){
        let obj = item;
        obj.selectId = item.materialCode;
        obj.factoryCode = other.factoryCode;//工厂
        obj.factoryDesc = other.factoryDesc;
        obj.factoryId = other.factoryId;

        obj.inventoryCode = other.inventoryCode;//库存地
        obj.inventoryDesc =other.inventoryDesc;
        obj.inventoryId = other.inventoryId;

        obj.supplierCode = other.supplierCode;//供应商
        obj.supplierDesc = other.supplierDesc;
        obj.supplierId = other.supplierId;
        
        state.selectedMatterStockList.push(obj);
      }
    }); 
    
  },

  //销售订单，选取物料
  setSelectedSaleOrderMaterial({state,dispatch,commit},{arr,other}){
    console.log(arr); 
    console.log(state.companyList,'=== 公司列表 ==');
    if(!arr) return;
    let selectedList = state.selectedMatterSale;//已选数组
    arr.forEach((item,index)=>{
      let obj = selectedList.find(v=>v.selectId===item.selectId);
      if(!obj){
        let obj = item;
        obj.taxm1 = 0;
        state.selectedMatterSale.push(obj);
      }
    });
  },

  //创建Bom，选取物料
  setSelectedBomMaterial({state,dispatch,commit},{arr,other}){
    console.log(arr);
    if(!arr) return;
    let selectedList = state.selectedMatterBom;//已选数组
    arr.forEach((item,index)=>{
      let obj = selectedList.find(v=>v.selectId===item.selectId);
      if(!obj){
        let obj = item;
        obj.projectClassify = "L";

        obj.compUnitId = item.basicUnitId;
        obj.compUnitDesc = item.basicUnitDesc;
        obj.compUnitCode = item.basicUnitCode;
        
        obj.bomComponent = item.materialCode;
        obj.bomComponentId = item.materialId;

        state.selectedMatterBom.push(obj);
      }
    });
  },

  //销售订单发货
  setSelectedSaleSendMaterial({state,dispatch,commit},{arr,other}){
    console.log(arr);
    console.log(state.companyList,'=== 公司列表 ==');
    if(!arr) return;
    let selectedList = state.selectedMatterSaleSend;//已选数组
    arr.forEach((item,index)=>{
      let obj = selectedList.find(v=>v.selectId===item.selectId);
      if(!obj){
        let obj = item;
        obj.taxm1 = 0;
        state.selectedMatterSaleSend.push(obj);
      }
    });
  },

  //销售订单退货
  setSelectedSaleCancelMaterial({state,dispatch,commit},{arr,other}){
    console.log(arr);
    console.log(state.companyList,'=== 公司列表 ==');
    if(!arr) return;
    let selectedList = state.selectedMatterSaleCancel;//已选数组
    arr.forEach((item,index)=>{
      let obj = selectedList.find(v=>v.selectId===item.selectId);
      if(!obj){
        let obj = item;
        obj.taxm1 = 0;
        state.selectedMatterSaleCancel.push(obj);
      }
    });
  },
  
//维护销售价格
setSelectedSaleHelpMaterial({state,dispatch,commit},{arr,other}){
  console.log(arr);
  console.log(state.companyList,'=== 公司列表 ==');
  if(!arr) return;
  let selectedList = state.selectedMatterSaleHelp;//已选数组
  arr.forEach((item,index)=>{
    let obj = selectedList.find(v=>v.selectId===item.selectId);
    if(!obj){
      let obj = item;
      obj.taxm1 = 0;
      state.selectedMatterSaleHelp.push(obj);
    }
  });
},

//创建生产订单
setSelectedProductOrderMaterial({state,dispatch,commit},{arr,other}){
  console.log(arr);
  if(!arr) return;
  let selectedList = state.selectedMatterProductOrder;//已选数组
  arr.forEach((item,index)=>{
    let obj = selectedList.find(v=>v.selectId===item.selectId);
    if(!obj){
      let obj = item;
      state.selectedMatterProductOrder.push(obj);
    }
  });
},
//创建生产订单（bom列表）
setSelectedProductOrderMaterials({state,dispatch,commit},{arr,other}){
  console.log(arr);
  if(!arr) return;
  let selectedList = state.selectedMatterProductOrders;//已选数组
  arr.forEach((item,index)=>{
    let obj = selectedList.find(v=>v.selectId===item.selectId);
    if(!obj){
      let obj = item;
      obj.projectClassify = "L"
      obj.compUnitId = item.basicUnitId
      obj.compUnitCode = item.basicUnitCode
      obj.compUnitDesc = item.basicUnitDesc
      obj.bomComponentId = item.materialId
      obj.bomComponent = item.materialCode
      obj.bomComponentDesc = item.materialDesc
      state.selectedMatterProductOrders.push(obj);
    }
  });
},
  //清空部分数据缓存
  clearCache({state,dispatch,commit}){
    //已选物料数据 - 物料数据
    state.selectedMatterList = [];
    //已选物料数据 - 库存物料数据
    state.selectedMatterStockList = [];
  }
}
export default{
  namespaced: true,
  state,
  mutations,
  actions
}
